module.exports = __webpack_public_path__ + "static/media/filter.6f7a06ee.svg";